/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type pdpSharedNotificationPdpSourcingModalConfigQueryVariables = {
    readonly itemId?: string | null;
    readonly userId?: string | null;
};
export type pdpSharedNotificationPdpSourcingModalConfigQueryResponse = {
    readonly viewer: {
        readonly item: {
            readonly displayInfo: {
                readonly ctas: {
                    readonly showRequestSourcing: boolean | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type pdpSharedNotificationPdpSourcingModalConfigQuery = {
    readonly response: pdpSharedNotificationPdpSourcingModalConfigQueryResponse;
    readonly variables: pdpSharedNotificationPdpSourcingModalConfigQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "itemId",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String",
            "defaultValue": ""
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "itemId",
            "variableName": "itemId"
        } as any),
        ({
            "kind": "Literal",
            "name": "pageType",
            "value": "PDP"
        } as any)
    ], v2 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "displayInfo",
        "storageKey": null,
        "args": [
            {
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userId"
            },
            {
                "kind": "Literal",
                "name": "page",
                "value": "pdp"
            }
        ],
        "concreteType": "ItemDisplayInfo",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "ctas",
                "storageKey": null,
                "args": null,
                "concreteType": "CTADisplay",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showRequestSourcing",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "pdpSharedNotificationPdpSourcingModalConfigQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "pdpSharedNotificationPdpSourcingModalConfigQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/)
                            ]
                        },
                        (v3 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "pdpSharedNotificationPdpSourcingModalConfigQuery",
            "id": "app-buyer-finding/230.0.0-2019-08-29T07:47:30.905Z/pdpSharedNotificationPdpSourcingModalConfigQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '91d69a12d3b62599b6b9dd3d5051d29a';
export default node;
